import { render, staticRenderFns } from "./gradePropertiesTable.vue?vue&type=template&id=1fda38fa"
import script from "./gradePropertiesTable.vue?vue&type=script&lang=js"
export * from "./gradePropertiesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports